import { INTENT_TYPE } from '../../constants';
import { resolveCueFamily } from '../features/cue-family';
import { EXPLAIN_CUES } from '../pack/lexicons';
import { type ConvergenceRule, type FeatureContext } from '../types';

/**
 * `C-EXPLAIN` (priority 955) — a request to be told about something.
 *
 * This family exists because stakeholder examples exposed it as a gap: `explain SHA` had
 * no rule at all and fell through to Search, which is the one destination that cannot
 * answer it.
 *
 * The boundary that keeps it safe is operand evidence. `explain SHA` names a subject;
 * `explain this` and a bare `explain` do not, and both stay on Search.
 */
export const matchesExplain = (features: FeatureContext): boolean =>
	resolveCueFamily(features, { cues: EXPLAIN_CUES }) !== null;

export const explainRule: ConvergenceRule = {
	type: INTENT_TYPE.CHAT,
	pattern: 'EXPLAIN_REQUEST',
	matches: matchesExplain,
};
